// Light (the default), dark or follow the device ("Auto"). Stored on this device only. index.html starts light, so a
// phone set to dark doesn't flash dark before this runs.
export type Theme = 'system' | 'light' | 'dark';

const KEY = 'inkglish.theme';
const DEFAULT: Theme = 'light';

/** The browser bar's color for each theme (the page background, --bg in styles/tokens.css). */
const BAR = { light: '#FAFAF8', dark: '#1F2023' } as const;

export function getTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'system' || t === 'light' || t === 'dark' ? t : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function applyTheme(theme: Theme = getTheme()): void {
  if (theme === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.dataset.theme = theme;
  // index.html has one bar color per device setting; a chosen theme uses its own color for both.
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    const device = meta.media.includes('dark') ? 'dark' : 'light';
    meta.content = BAR[theme === 'system' ? device : theme];
  }
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // Private mode: the choice lasts until the page closes.
  }
  applyTheme(theme);
}
